import { Injectable } from '@angular/core';
import {EsBsModalService} from "../bsModalService/bs-modal.service";
import {BehaviorSubject, Observable, Subject} from "rxjs";
import {ItemManagerService} from "../itemManager/item-manager.service";
import {MapPosition} from "../../models/MapPosition";
import {ToolsService} from "../toolsService/tools.service";
import {subdivideArray} from "cesium";
import {Item} from "../../models/Item";

@Injectable({
  providedIn: 'root'
})
export class GpxProcessService {

  public modalElmString = '#es-gpx-import-modal';
  private config:any = {};
  private _configUpdated$: Subject<any> = new Subject();
  get configUpdated$(){
    return this._configUpdated$.asObservable();
  }
  private _modalEventFires$: Subject<any> = new Subject();
  get modalEventFires$(){
    return this._modalEventFires$.asObservable();
  }

  set updateConfig(val){
    this.config = val;
    this._configUpdated$.next(this.config);
  }

  constructor(private modalService: EsBsModalService, private toolManager: ToolsService, private im: ItemManagerService) {
    this.initListeners();
  }

  private initListeners(){
    this.modalService.modalUpdated.subscribe((eventName)=>{
      if (this.modalElmString == this.modalService.currentModal){
          this._modalEventFires$.next(eventName);
      }
    })
  }

  public openModal(){
    this.modalService.currentModal = this.modalElmString;
    this.modalService.openModal();
  }

  public closeModal(){
    this.modalService.closeModal();
  }

  processDependedTools(config:any){
    this.updateConfig = config;

    for (let i in this.config){
      if (!this.config.hasOwnProperty(i) || !this.config[i].tool){
        continue;
      }
      let _simpleConfig = this.config[i];
      let preparedConfig = {
        tool: Object.assign({}, this.toolManager.getToolById(_simpleConfig.tool)),
        position: _simpleConfig.positions.map((point) => {
          return new MapPosition(point);
        })
      };
      this.toolManager.assignMappings(preparedConfig.tool);
      preparedConfig.tool.name = _simpleConfig.name;
      if (!preparedConfig.tool.params){
        preparedConfig.tool.params = {};
      }
      preparedConfig.tool.params['__gpx_imported'] = {'value': _simpleConfig.id};

      this.im.addItemByOutsideConfig(preparedConfig).subscribe((item:Item)=>{
        item.getSubject(Item.AFTER_DRAWN_SUBJECT).asObservable().subscribe(()=>{
          item.centerOnObj();
        });
      });
    }
  }
}
